import NoResultsButton from './NoResultsButton.vue'

export default NoResultsButton
